var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stop)?_c('el-button',{ref:"ref-button",class:{
    'comman btn-gray': _vm.gray,
    'comman btn-green': _vm.green,
    'comman btn-red': _vm.red,
    'comman btn-blue': _vm.blue,
    'comman btn-purple': _vm.purple,
    'comman btn-warning': _vm.warningBtn,
    'comman btn-all-red': _vm.allRed,
  },attrs:{"size":_vm.size,"type":_vm.type,"disabled":_vm.disabled,"plain":_vm.plain},on:{"click":function($event){$event.stopPropagation();return _vm.handlerClick($event)}}},[(_vm.icon&&!_vm.rightIcon)?_c('font-awesome-iconwarning',{attrs:{"icon":[_vm.iconType, _vm.icon]}}):_vm._e(),_c('span',{staticClass:"btn-label"},[_vm._t("default")],2),(_vm.rightIcon)?_c('font-awesome-icon',{attrs:{"icon":[_vm.iconType, _vm.icon]}}):_vm._e()],1):_c('el-button',{ref:"ref-button",class:{
    'comman btn-gray': _vm.gray,
    'comman btn-green': _vm.green,
    'comman btn-red': _vm.red,
    'comman btn-blue': _vm.blue,
    'comman btn-purple': _vm.purple,
    'comman btn-warning': _vm.warningBtn,
    'comman btn-all-red': _vm.allRed,
  },attrs:{"size":_vm.size,"type":_vm.type,"disabled":_vm.disabled,"plain":_vm.plain},on:{"click":_vm.handlerClick}},[(_vm.icon&&!_vm.rightIcon)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":[_vm.iconType, _vm.icon]}}):_vm._e(),_c('span',{staticClass:"btn-label"},[_vm._t("default")],2),(_vm.rightIcon)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":[_vm.iconType, _vm.icon]}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }